
import VideoHorizontal from "../../../assets/filled/VideoHorizontal.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function VideoHorizontalIcon({ className, dataTestid = "VideoHorizontalIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <VideoHorizontal data-testid={dataTestid} className={classes} {...rest} />
  );
}
